var App = App || {};
App.Initialization = App.Initialization || {};

App.Initialization['component.cmpIcons'] = (function () {
    'use strict';

    const CONFIG = {
        ICON_SELECTOR: '.cmp--icon',
        ICON_ANIMATION: 'animate__fadeInUp',
        ICON_STAGGER: 150
    };

    const initialize = (block) => {
        if (!block || !block.id) return;

        if (block.querySelectorAll(CONFIG.ICON_SELECTOR).length === 0) return;

        App.ZagScrollAnimate.initialize(`#${CSS.escape(block.id)}`, {
            targets: [
                { selector: CONFIG.ICON_SELECTOR, type: CONFIG.ICON_ANIMATION, stagger: CONFIG.ICON_STAGGER }
            ]
        });
    };

    return {
        initialize
    };

})();
